var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"btn-print-word",on:{"click":_vm.printWordStatistic}},[_vm._v(_vm._s(_vm.$t("Печать в Word")))])}
var staticRenderFns = []

export { render, staticRenderFns }